import { MuiF } from '../../../../../../../Mui/F/Function/module/MuiF.js';
import { VectorEditorKeyringFreeCreatorPCCuttingLineAutoMuiF } from '../Mui/module/VectorEditorKeyringFreeCreatorPCCuttingLineAutoMuiF.js';

export const makeCuttingLineAuto = ({
  art_board: { width: art_board_width, height: art_board_height },
  makeTargetImageEl,
  postProcess,
}) =>
  MuiF.pushPage(VectorEditorKeyringFreeCreatorPCCuttingLineAutoMuiF.page, (page, [tab]) => {
    const tab_appending = tab.appending;
    tab.appending = (tab_el) => {
      tab_el.__mp_art_board_width = art_board_width;
      tab_el.__mp_art_board_height = art_board_height;
      tab_el.__mp_makeTargetImageEl = makeTargetImageEl;
      tab_el.__mp_postProcess = postProcess;

      return tab_appending.call(tab, tab_el);
    };
  }).catch(async (error) => {
    try {
      await MuiF.popPage();
    } catch (error) {
      console.error(error);
    }

    throw error;
  });
